export const arraysHaveSameElements = (array1 = [], array2 = []) => {
  if (array1.length === array2.length) {
    const difference = array1.filter((element) => !array2.includes(element));
    return difference?.length === 0;
  }
  return false;
};
